import * as dayjs from 'dayjs';

/**
 * @author Matheus Vieira <matheus.vieira@deal.com.br>
 * @since 2020-11-17
 */
const paramsToObject = entries => {
  const result = {};
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
};

const getUrlParams = () => {
  const urlParams = new URL(window.location).searchParams;
  const entries = urlParams.entries();

  return paramsToObject(entries);
};

const checkIfLinkIsValid = params => {
  if (Object.keys(params).length === 0) {
    return false;
  }
  const { id, pt, pn, ad } = params;

  if (id == null || pt == null || pn == null || ad == null) {
    return false;
  }

  for (const key in params) {
    if (params[key] !== null && params[key] !== '') {
      return true;
    }
  }
  return false;
};

const checkIfLinkIsExpired = params => {
  const { ad } = params;

  if (!ad) return false;

  const linkDate = dayjs().millisecond(ad);
  const today = dayjs();

  return today.diff(linkDate, 'hour') > 48;
};

export { getUrlParams, checkIfLinkIsValid, checkIfLinkIsExpired };
